import { api } from "../../http";

async function GetFindDataByIdRRIM(id) {
  try {
    
    const data = await api.get(`/rrim/find/${id}`);

    return data;


  } catch (e) {
    console.log(e.message);
  }
}

async function GetFindDataRRIMByAttr(att,valor,status) {
  try {
    
    const data = await api.get(`/rrim/findByFilter`, { 
      params:{
        atributo: att,
        valor,
        status
      }
    });

    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetFindDataByIdRRIM, GetFindDataRRIMByAttr };
